import React from "react";
import { useFlag } from "@unleash/proxy-client-react";
import { Box } from "@reverb-ui/react";
export var MarketplaceIntegration = function () {
    var showMarketplace = useFlag("account.marketplace-integration");
    if (!showMarketplace) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Box, { h: "100%", w: "100%", overflow: "hidden" },
        React.createElement("iframe", { style: {
                height: "100%",
                width: "100%",
            }, title: "marketplace", src: process.env.MARKETPLACE_URL })));
};
